import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Translations } from 'src/app/core/models';
import { overview } from 'src/app/core/translations/overview';

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.scss'],
})
export class SiteMapComponent {
  isHandsetPortrait: boolean = false;

  currentLanguage: string = '';
  languageTranslations: any = overview;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  goToLink(linkName: string) {
    this.router.navigate([`/${linkName}`])
  }

  goToPage(pageName: string) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    this.router.navigate([`info/${baniLanguageString}/${pageName}`]);
  }
}
